import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ExpansionPanelComp from '../../common/ExpansionPanelComp';
import DatiQuestionarioIvass from './sezione/DatiQuestionarioIvass';

const styles = theme => ({
  root: {
    width: '100%',
  },
});
			
function QuestionarioIvassPanel(props) {
	
  const { classes, isValida } = props;
  return (
    <div className={classes.root}> 
      <ExpansionPanelComp titolo={'questionarioIvass'} componente={DatiQuestionarioIvass} isValida={isValida} /> 
    </div>
  );
}

QuestionarioIvassPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(QuestionarioIvassPanel);
